import React from 'react'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
import { Link } from 'react-router-dom'
import { useSupport } from '../../Hook/App'
function Support() {
    const { tickets, info } = useSupport()

    return (
        <Layout>
            <HeaderMain lable="ارتباط با پیشتیبانی" />
            <div className="all-support">
                <div className="p-main ">
                    <p className="p-help">کمک نیاز دارید؟</p>
                    <p>تیم پیشتیبانی به صورت بیست و چهار ساعته اماده پاسخگویی ب شماست.</p>
                    {info && String(info.telephone).length > 1 ?
                        <p>تلفن تماس : <a href={"tel:" + info.telephone}>{info.telephone}</a></p>
                        : null}
                    {info && String(info.address).length > 1 ?
                        <p>آدرس : {info.address}</p>
                        : null}
                </div>
                <div className="all-btn" >
                    {tickets &&
                        tickets.length ?
                        <div className='tickets'>
                            <h6 className='mb-4'>لیست پیام ها</h6>
                            {
                                tickets.map((ticket, i) => {
                                    let status = "درحال بررسی";
                                    if (ticket.status === 'wait') {
                                        status = "درحال بررسی"
                                    }
                                    if (ticket.status === 'answer') {
                                        status = "پاسخ داده شد"
                                    }
                                    if (ticket.status === 'close') {
                                        status = "بسته شد"
                                    }
                                    return (
                                        <div key={i} className='ticket'>
                                            <small>{ticket.id}#</small>
                                            <small>{ticket.title}</small>
                                            <small className='badge bg-light text-dark'>{status}</small>
                                            <Link to={"/Ticket/" + ticket.id} state={{ ticket: ticket }}><i className='far fa-arrow-left'></i></Link>
                                        </div>
                                    )
                                })
                            }
                        </div> : null
                    }
                    <Link to={"/MessageSuport"} className="d-block text-center btn-message">
                        <a >
                            <i class="far fa-envelope"></i>
                            ارسال پیام
                        </a>
                    </Link>
                    <button className="btn-message-call">
                        <i class="far fa-phone"></i>
                        تماس با ما
                    </button>
                </div>
              
            </div>

        </Layout>
    )
}

export default Support